// extracted by mini-css-extract-plugin
export default {"identityRow":"SupplierIdentity_identityRow__B8Oyd","identityField":"SupplierIdentity_identityField__jcezK","identitySelector":"SupplierIdentity_identitySelector__AC88B"};